import { Component, Input } from '@angular/core';

import { PbbImgErrorDirective } from '@core/directives/pbb-img-error.directive';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'pbb-bank-info',
  templateUrl: './bank-info.component.html',
  styleUrls: ['./bank-info.component.scss'],
  standalone: true,
  imports: [PbbImgErrorDirective, MatIconModule],
})
export class BankInfoComponent {
  @Input() logo?: string;
  @Input() imageSrc?: string;
  @Input() name?: string;
  @Input() defaultLogoPath: string = 'assets/images/bank.png';
}
